import React, { Component } from "react";
import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Row, Form } from "reactstrap";
import queryString from "query-string";
import ReactSelect from "react-select";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getPositionsList,
  setPositions,
} from "../../../store/positions/actions";
import {
  getBonuses,
  postBonuses,
  patchBonuses,
  deleteBonuses,
  setBonuses
} from "../../../store/salary-bonuses/actions";
import SalaryBonusModal from "./components/SalaryBonusModal/SalaryBonusModal";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class SalaryBonuses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      viewAddBonuses: false,
      editData: null,
      selectedFilter: null,
      defaultPositions: {
        count: 0,
        next: null,
        previous: null,
        page: 1,
        sizePerPage: 10,
        title: "",
        results: [],
      },
      positions: [],
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    const location = this.props.history.location;

    let parsedSearch = queryString.parse(this.props.history.location.search);
    let dataPositions = this.props.positions;
    let dataBonuses = this.props.data;

    dataPositions["sizePerPage"] = "0";
    this.props.getPositionsList(dataPositions);

    if (Object.keys(parsedSearch).length !== 0) {
      let formQueryString = queryString.stringify(Object.assign(parsedSearch));
      location.search = formQueryString;
      this.props.history.replace(location);
      dataBonuses["position__title"] = parsedSearch.position;
      this.handleSelectPosition({
        label: parsedSearch.position,
        value: parsedSearch.position,
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.positions !== prevProps.positions) {
      this.props.positions.results.map(i => {
        this.state.positions.push({
          label: i.title,
          value: i.id,
        });
      });

      if (
        this.props.positions.results.length > 0 &&
        this.state.selectedFilter === null
      ) {
        let dataBonuses = this.props.data;
        dataBonuses["position__title"] =
          this.props.positions.results[1]["title"];
        this.handleSelectPosition({
          label: 'ALL', //this.props.positions.results[0]["title"],
          value: 'ALL', // this.props.positions.results[0]["title"],
        });
        this.props.getBonuses(dataBonuses);
      }
    }
  }

  componentWillUnmount() {
    this.props.setPositions(this.state.defaultPositions);
    this.props.setBonuses({
      ...this.props.data,
      search: '',
      ordering: '',
      results: [],
    })
  }

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  handleTableChange = data => {
    this.props.getBonuses(data);
  };

  toggleViewAddBonusesModal = () => {
    this.setState(prevState => ({
      viewAddBonuses: !prevState.viewAddBonuses,
      editData: null,
    }));
  };

  onClickRow = (e, row, type) => {
    this.setState(prevState => ({
      viewAddBonuses: !prevState.viewAddPosition,
      editData: type === "edit" ? row : null,
    }));
  };

  handleSelectPosition = item => {
    let dataBonuses = this.props.data;
    // dataBonuses["position__title"] = item.value == 'ALL' ? '' : item.value;

    this.setState({
      selectedFilter: item,
    });

    const prevSearch = queryString.parse(this.props.history.location.search);
    // let formQueryString = queryString.stringify(
    //   Object.assign(prevSearch, {
    //     position: item.value,
    //   })
    // );

    // this.props.history.location.search = formQueryString;
    // this.props.history.replace(this.props.history.location);
    this.props.getBonuses(dataBonuses);
  };

  render() {
    const positionNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => this.onClickRow(e, row, "edit")}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const nameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => this.onClickRow(e, row, "edit")}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const rangeFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => this.onClickRow(e, row, "edit")}>
          {row.date_from} - {row.date_to}
        </LegalNameLink>
      );
    };

    const bonusPercentFormatter = (cell, row, label) => {
      let num = row[label] * 100;
      return (
        <LegalNameLink onClick={e => this.onClickRow(e, row, "edit")}>
          {num.toFixed(1)}%
        </LegalNameLink>
      );
    };

    const percentFormatter = (cell, row, label) => {
      let num = row[label]; // * 100;
      return (
        <LegalNameLink onClick={e => this.onClickRow(e, row, "edit")}>
          {num ? `${num.toFixed(1)}%` : `-`}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete bonus`,
          onConfirm: () => {
            this.props.deleteBonuses(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };
      return (
        <>
          {this.props.permissions?.["change_salarybonusmodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => this.onClickRow(e, row, "edit")}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </button>
          )}
          {this.props.permissions?.["delete_salarybonusmodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    // const columns = [
    //   {
    //     dataField: "position",
    //     text: "Position",
    //     sort: false,
    //     formatter: (e, row) => positionNameFormatter(e, row, "position"),
    //   },
    //   {
    //     dataField: "plan_progress_percent_from",
    //     text: "Plan progress percent from",
    //     sort: false,
    //     formatter: (e, row) =>
    //       bonusPercentFormatter(e, row, "plan_progress_percent_from"),
    //   },
    //   {
    //     dataField: "plan_progress_percent_to",
    //     text: "Plan progress percent to",
    //     sort: false,
    //     formatter: (e, row) =>
    //       bonusPercentFormatter(e, row, "plan_progress_percent_to"),
    //   },
    //   {
    //     dataField: "sales_percent",
    //     text: "Sales percent",
    //     sort: false,
    //     formatter: (e, row) => bonusPercentFormatter(e, row, "sales_percent"),
    //   },
    //   {
    //     dataField: "Actions",
    //     text: "Actions",
    //     sort: false,
    //     formatter: (e, row) => actionsFormatter(e, row),
    //   },
    // ];

    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (e, row) => nameFormatter(e, row, "name"),
      },
      {
        dataField: "type",
        text: "Type",
        sort: true,
        formatter: (e, row) => nameFormatter(e, row, "type"),
      },
      {
        dataField: "sum",
        text: "Sum",
        sort: true,
        formatter: (e, row) => nameFormatter(e, row, "sum"),
      },
      {
        dataField: "percent",
        text: "Percent",
        sort: true,
        formatter: (e, row) => percentFormatter(e, row, "percent"),
      },
      {
        dataField: "date_from",
        text: "Date range",
        sort: true,
        formatter: (e, row) => rangeFormatter(e, row, "date_from"),
      },
      {
        dataField: "Actions",
        text: "Actions",
        sort: false,
        formatter: (e, row) => actionsFormatter(e, row),
      },
    ];

    const getPositions = (data) => {
      let positions = data.map((i) => {
        return {
          label: i.title,
          value: i.title
        }
      })

      return [{ label: 'ALL', value: "ALL" }, ...positions]
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Media buyer bonuses | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Salary Bonuses"
              link="/dashboard"
            />

            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>Are you sure want to delete this bonus?</p>
              </SweetAlert>
            )}

            {this.state.viewAddBonuses && (
              <SalaryBonusModal
                toggle={this.toggleViewAddBonusesModal}
                isOpen={this.state.viewAddBonuses}
                addBonus={this.props.postBonuses}
                updateBonus={this.props.patchBonuses}
                editData={this.state.editData}
                permissions={this.props.permissions}
                positions={this.state.positions}
                selectedFilter={this.state.selectedFilter}
              />
            )}

            {/* <StyledRow>
              <div className="col-12">
                <StyledCard>
                  <CardBody
                    style={{
                      padding: "1.25rem 0",
                    }}
                  >
                    <FilterContainer className="d-flex justify-content-between align-items-end">
                      <div>
                        <Form className="row gy-2 gx-3 align-items-center">
                          <div className="col-sm-auto">
                            <span>{"Filter by"}:</span>
                          </div>
                          <div className="col-sm-auto">
                            <CustomSelect
                              defaultValue={this.props.positions?.results ? getPositions(this.props.positions?.results)[0] : {}}
                              value={this.state.selectedFilter}
                              onChange={this.handleSelectPosition}
                              isLoading={this.props.loading}
                              options={this.props.positions?.results ? getPositions(this.props.positions?.results) : []}
                              // options={
                              //   this.props.positions.results.map(i => {
                              //     return {
                              //       label: i.title,
                              //       value: i.title,
                              //     };
                              //   }) || []
                              // }
                              // classNamePrefix="select2-selection"
                              required
                            />
                          </div>
                        </Form>
                      </div>
                    </FilterContainer>
                  </CardBody>
                </StyledCard>
              </div>
            </StyledRow> */}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                      disable_pages
                    >
                      {this.props.permissions?.["add_salarybonusmodel"] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleViewAddBonusesModal}
                        >
                          <i className="mdi mdi-plus me-1" /> Add bonus
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const CustomSelect = styled(ReactSelect)`
  min-width: 240px;
`;

const FilterContainer = styled.div`
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 300px;
  }
`;

const StyledRow = styled.div`
  padding: 0;
  margin: 0;
  z-index: 4;
  position: sticky;
  top: 69px;
`;

const StyledCard = styled(Card)`
  box-shadow: none !important;
  background: #f8f8fb;
  border-radius: 0.1px;
`;

const LegalNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

SalaryBonuses.propTypes = {
  data: PropTypes.shape({
    position__title: PropTypes.string,
    page: PropTypes.number,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  positions: PropTypes.shape({
    sizePerPage: PropTypes.any,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  permissions: PropTypes.object.isRequired,
  getBonuses: PropTypes.func.isRequired,
  postBonuses: PropTypes.func.isRequired,
  patchBonuses: PropTypes.func.isRequired,
  deleteBonuses: PropTypes.func.isRequired,
  getPositionsList: PropTypes.func.isRequired,
  setPositions: PropTypes.func.isRequired,
  setBonuses: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  data: state.SalaryBonuses.data,
  loading: state.SalaryBonuses.loading,
  permissions: state.User.permissions,
  positions: state.Positions.data,
});

export default connect(mapStateToProps, {
  getBonuses,
  setBonuses,
  postBonuses,
  patchBonuses,
  deleteBonuses,
  getPositionsList,
  setPositions,
})(SalaryBonuses);
